<template>
  <settings-card style="width: 100%">
    <template v-slot:title>
      Avec quelle série veux-tu apprendre ?
    </template>
    <!--
    <template v-slot:message v-if="messageDisplay">
      <div class="message"><div>
        <i class="fa-solid fa-circle-exclamation"></i> Nous ne disposons pour le moment que du catalogue Netflix.
        <br><span style="font-style: italic"><i class="fa-solid fa-lightbulb-exclamation-on"></i> Choisis une série qui correspond à ton niveau.</span>
        <br><span style="font-style: italic"><i class="fa-solid fa-lightbulb-exclamation-on"></i> Commencer par une série qui t'est familière facilitera ta progression.</span>
      </div>
        <div style="width: max-content" class="horizontalCenter">
          <standard-button @click="messageDisplay = false" :color-class="'olive'">Compris</standard-button>
        </div>
      </div>
    </template>
    -->
    <template v-slot:content>
      <div class="showRequest" v-if="!isMobile">
        <div v-if="!mailSent" class="flexwrap">
          <div @click="showRequest = true" v-if="!showRequest" class="clickable">
            <i class="fa-solid fa-circle-exclamation"></i> Manque-t-il une série / saison ?
          </div>

          <form v-else class="flexwrap">
            <input v-model="requestedShowTitle" placeholder="Titre de la série">
            <standard-button color-class="olive" @click="sendMail()">Envoyer</standard-button>
          </form>
        </div>

        <div v-else>
          La série sera ajoutée au plus vite (quelques heures à quelques jours)
        </div>
      </div>
      <div class="selectShow-all" v-if="dataLoaded.topShow">
        <div id="selectShow-content" v-if="!isMobile">
          <div id="selectShow-showslist">
            <shows-list @selected="onSelected"></shows-list>
          </div>

          <div id="selectShow-selected" class="flexwrap" v-if="selectedSeasonId !== -1">
            <div style="width: 90%">
              <br><span style="font-style: italic"><i class="fa-solid fa-lightbulb"></i> Choisis une série qui correspond à ton niveau.</span>
              <br><span style="font-style: italic"><i class="fa-solid fa-lightbulb"></i> Commence par une série qui t'est familière pour faciliter ta progression.</span>
            </div>
            <transition name="slide-fade" mode="out-in">
              <show-presentation :estimated_level="source === 'guide'?guideTempProfile.estimated_level:profile.datas.estimated_level" :selected-season-id="selectedSeasonId" @selected="onSelected" :key="seasonsData[selectedSeasonId].show_id"></show-presentation>
            </transition>
            <standard-button color-class="olive" @click="selectSeason">Choisir cette saison</standard-button>
          </div>
        </div>

        <div id="selectShow-content" v-else>
          <div id="selectShow-showslist" v-if="page==0">
            <shows-list @selected="onSelected"></shows-list>
          </div>
          <div id="selectShow-selected" class="flexwrap" v-else-if="selectedSeasonId !== -1">
            <div class="flexwrap centercenter">
              <i class="fas fa-arrow-left" style="font-size: 180%; text-shadow: 0 0 0.4vw #000000aa; margin-right: 5vw; color:var(--goalBackgroundColor)" @click="page=0"></i>
              <standard-button color-class="olive" @click="selectSeason">Choisir cette saison</standard-button>
            </div>
            <transition name="slide-fade" mode="out-in">
              <div style="max-height: calc(100% - 5vw); overflow: auto; padding: 0 5vw 5vw 5vw;">
                <show-presentation :estimated_level="source === 'guide'?guideTempProfile.estimated_level:profile.datas.estimated_level" :selected-season-id="selectedSeasonId" @selected="onSelected" :key="seasonsData[selectedSeasonId].show_id"></show-presentation>
              </div>
            </transition>


          </div>
        </div>
      </div>
      <div class="flexwrap centercenter" style="width: 100%; height: 100%" v-else>
        <loading-logo></loading-logo>
      </div>

      </template>

  </settings-card>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import StandardButton from "@/components/standardButton";
import ShowPresentation from "@/components/showPresentation";
import {baseShowsNumber} from "@/variables";
import {API_URL} from "@/App";
import axios from "axios";
import {manageUserDatas} from "@/mixins/manageUserDatas";
import SettingsCard from "@/components/settingsCard";
import LoadingLogo from "@/components/loadingLogo";

export default {
name: "selectNewShow",

  mixins: [manageUserDatas],

  components: {
    LoadingLogo,
    SettingsCard,
    ShowPresentation,
    StandardButton,
    showsList: () => import(/* webpackPrefetch: true */ '@/components/showsList')
  },

  created() {
  //window.setTimeout(() => this.messageDisplay = false, 2000)

    if(!this.dataLoaded.topShow) {
      this.fetchData()
      this.selectedShow = this.currentShow
    }

    else {
      // Si le composant est utilisé dans le guide :
      // Si l'utilisateur n'a encore rien choisi, on initie tempProfile avec un estimated_level de -1
      // Si la propriété existe déjà dans le prop guideTempProfile, on initie tempProfile avec
      if(this.source === "guide") {
        if(this.guideTempProfile.current_season !== -1) {
          this.selectedSeasonId = this.guideTempProfile.current_season
        }
        else {
          this.selectedSeasonId = this.seasonsIndex[0].id
        }
        this.tempProfile = Object.assign({}, this.guideTempProfile);
      }
      else {
        this.tempProfile = Object.assign({}, this.profile.datas);
        if(this.profile.datas.ongoing_season_obj === null) {
          this.selectedSeasonId = -1
        }
        else {
          this.selectedSeasonId = this.profile.datas.ongoing_season_obj.id
        }
      }
    }


  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'seasonsData',
      'showsData',
      'seasonsIndex',
      'dataLoaded',
        ],
    ),

  },
  methods: {
    ...mapActions('global', [
      'set_catalogData',
      'set_dataLoaded',
        'set_dataReload'
    ]),
    ...mapActions('show', [
      'set_currentShow',
      'set_seasonRequested',
    ]),
    fetchData() {
      let urlBasic = `${API_URL}/api/catalog/50/`
      axios.get(urlBasic)
          .then(response => {
            return response.data;
          })
          .then(data => {
            this.set_catalogData(data);
            this.set_dataLoaded({name: 'topShow', value: true});

            let urlBasic = `${API_URL}/api/catalog/1834/`
            axios.get(urlBasic)
                .then(response => {
                  return response.data;
                })
                .then(data => {
                  this.set_catalogData(data);
                  this.set_dataLoaded({name: 'basicShow', value: true});
                });

          });


      // Si l'utilisateur est enregistré, on va chercher les séries dont une saison au moins a été commencée
      // On récupère les 4 plus récentes pour les mettre en avant
    },
    onSelected (value) {
      this.selectedSeasonId = value
      this.page=1
    },
    selectSeason: function () {
      if(this.source === "guide") {
        this.tempProfile.current_season = this.selectedSeasonId,
        this.$emit('profileChanged', this.tempProfile)
        this.$emit('setShowTitle', this.showsData[this.seasonsData[this.selectedSeasonId].show_id].english_title)
      }
      else {
        this.profile.datas.ongoing_season_obj = this.seasonsData[this.selectedSeasonId]
        this.profile.datas.ongoing_show_obj = this.showsData[this.profile.datas.ongoing_season_obj.show_id]
        this.patchUserInfo()
        this.$router.push({name: 'saison', params: {saisonId: this.selectedSeasonId}});
      }
    },
    patchUserInfo() {
      let payload = {
        "current_season" : this.selectedSeasonId,
      }
      const url = `${API_URL}/api/auth0user/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.patch(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              .then(response => {
                this.set_seasonRequested(payload.current_season)
              })
        }

        else {
          console.log(error)
        }
      })
    },

    sendMail() {
      this.$loadScript("https://smtpjs.com/v3/smtp.js")
          .then(() => {
            // Script is loaded, do something
            window.Email.send({
              Host: "email-smtp.eu-west-2.amazonaws.com",
              Username: "AKIA2VM4R3QQO2FT3O6Z",
              Password: "BNPVx6bdVowNio63dbQBgz9979ZXVAV6CyK/yl8CmpQS",
              To: 'fanny.destenay@learnandwatch.com',
              From: "fanny.destenay@learnandwatch.com",
              Subject: "Demande d'ajout de série / saison",
              Body: 'Un utilisateur n\'a pas trouvé sa série Netflix sur Learn and Watch : \n' + '\n Série : ' + this.requestedShowTitle + '\n saison : ' + this.requestedSeasonNumber
            }).then(message => {
                this.mailSent = true;
              }
            );
          })
          .catch((error) => {
            console.log(error)
          });
    }

  },

  watch: {
    'dataLoaded.topShow': function() {
      if(this.dataLoaded.topShow) {
        // Si le composant est utilisé dans le guide :
        // Si l'utilisateur n'a encore rien choisi, on initie tempProfile avec un estimated_level de -1
        // Si la propriété existe déjà dans le prop guideTempProfile, on initie tempProfile avec
        if(this.source === "guide") {
          if(this.guideTempProfile.current_season !== -1) {
            this.selectedSeasonId = this.guideTempProfile.current_season
          }
          else {
            this.selectedSeasonId = this.seasonsIndex[0].id
          }
          this.tempProfile = Object.assign({}, this.guideTempProfile);
        }
        else {
          this.tempProfile = Object.assign({}, this.profile.datas);
          if(this.profile.datas.ongoing_season_obj === null) {
            this.selectedSeasonId = -1
          }
          else {
            this.selectedSeasonId = this.profile.datas.ongoing_season_obj.id
          }
        }
      }
    }
  },

  data: function () {
    return {
      selectedSeasonId: 1,
      page: 0,
      showRequest: false,
      requestedShowTitle: '',
      requestedSeasonNumber: -1,
      mailSent: false,
      messageDisplay: true,
    }
  }

}
</script>

<style scoped>
  .selectShow-all {
    display: grid;
    grid-template-rows:100%;
    grid-gap: 1vw;
    height: calc(100% - 1vw);
    max-height: calc(100% - 1vw);
    width: calc(100% - 2vw);
    padding: 1vw 1vw 0 1vw;
  }

  #selectShow-content{
    display: grid;
    grid-gap: 1vw;
    position: relative;
    grid-template-columns: auto 1fr;
    grid-template-rows: 100%;
    height: 100%;
    max-height: 100%;
  }

  .showRequest{
    position: absolute;
    right: 1vw;
    top: -2vw;
    font-size: 0.9em;
    color: #222222;
  }

  #selectShow-showslist{
    height: 100%;
    max-height: 100%;
  }

  #selectShow-selected{
    justify-content: center;
    justify-items: center;
    height: min-content;
    width: fit-content;
  }

  .currentShow {
    display: flex;
  }

  .message {
    height: 100%;
    display: grid;
    grid-template-rows: 3fr 1fr;
  }

  @media screen and (max-device-width: 767px) {

    .selectShow-all {
      display: grid;
      grid-template-rows:100%;
      grid-gap: 1vw;
      height: calc(100% - 2vw);
      max-height: calc(100% - 2vw);
      width: 100%;
      padding: 2vw 0 0 0;
    }

    #selectShow-content{
      grid-template-columns: 1fr;
    }

    #selectShow-selected{
      display: grid;
      grid-template-rows: auto 1fr;
      justify-content: center;
      justify-items: center;
      height: calc(100% - 5vw);
      width: 100%;
      grid-gap: 5vw;
      padding: 5vw 0 0 0;
    }
  }
</style>